export default __webpack_public_path__ + "static/media/kitchen2.f61b8d56.webp";